export interface RouteConfig {
  path: string;
  name: string;
}

export const routes: RouteConfig[] = [
  { path: "/", name: "Home" },
  { path: "/dir-mes", name: "Director's Message" },
  { path: "/prod", name: "Products" },
  { path: "/prod/tablets", name: "Products - Tablets" },
  { path: "/prod/capsules", name: "Products - Capsules" },
  { path: "/prod/softgels", name: "Products - Softgels" },
  { path: "/prod/dental-gargle", name: "Products - Dental & Gargle" },
  { path: "/prod/paediatric", name: "Products - Paediatric" },
  { path: "/prod/syrup", name: "Products - Syrup" },
  { path: "/prod/spray", name: "Products - Spray" },
  { path: "/prod/dusting-powder", name: "Products - Dusting Powder" },
  { path: "/prod/ear-eye-drop", name: "Products - Ear & Eye Drop" },
  { path: "/prod/nasal-spray", name: "Products - Nasal Spray" },
  { path: "/prod/powder-sachet", name: "Products - Powder & Sachet" },
  { path: "/prod/infusions", name: "Products - Infusions" },
  { path: "/prod/rota-caps", name: "Products - Rota Caps" },
  { path: "/prod/ointments", name: "Products - Ointments" },
  { path: "/prod/others", name: "Products - Others" },
  { path: "/therapy", name: "Therapeutics" },
  { path: "/therapy/analgesics", name: "Therapy - Analgesics" },
  { path: "/therapy/antacids", name: "Therapy - Antacids" },
  { path: "/therapy/antibacterials", name: "Therapy - Antibacterials" },
  { path: "/therapy/antibiotics", name: "Therapy - Antibiotics" },
  { path: "/therapy/anticancer", name: "Therapy - Anticancer" },
  { path: "/therapy/anticoagulant", name: "Therapy - Anticoagulant" },
  { path: "/therapy/antidepressants", name: "Therapy - Antidepressants" },
  { path: "/therapy/antidiabetic", name: "Therapy - Antidiabetic" },
  { path: "/therapy/antidiarrheal", name: "Therapy - Antidiarrheal" },
  { path: "/therapy/antiepileptic", name: "Therapy - Antiepileptic" },
  { path: "/therapy/antifungals", name: "Therapy - Antifungals" },
  { path: "/therapy/antihistamines", name: "Therapy - Antihistamines" },
  { path: "/therapy/anti-inflammatories", name: "Therapy - Anti-inflammatories" },
  { path: "/therapy/antipsychotic", name: "Therapy - Antipsychotic" },
  { path: "/therapy/antipyretics", name: "Therapy - Antipyretics" },
  { path: "/therapy/antispasmodic", name: "Therapy - Antispasmodic" },
  { path: "/therapy/antiviral", name: "Therapy - Antiviral" },
  { path: "/therapy/asthma", name: "Therapy - Asthma" },
  { path: "/therapy/cardiology", name: "Therapy - Cardiology" },
  { path: "/therapy/cardiovascular", name: "Therapy - Cardiovascular" },
  { path: "/therapy/cold-and-cough", name: "Therapy - Cold and Cough" },
  { path: "/therapy/dental", name: "Therapy - Dental" },
  { path: "/therapy/depressant", name: "Therapy - Depressant" },
  { path: "/therapy/dermatology", name: "Therapy - Dermatology" },
  { path: "/therapy/diabetic", name: "Therapy - Diabetic" },
  { path: "/therapy/endocrinology", name: "Therapy - Endocrinology" },
  { path: "/therapy/endocrinology-hormonal", name: "Therapy - Endocrinology and Hormonal" },
  { path: "/therapy/gastroenterology", name: "Therapy - Gastroenterology" },
  { path: "/therapy/general-otc", name: "Therapy - General and OTC" },
  { path: "/therapy/gynecology-fertility", name: "Therapy - Gynecology and Fertility" },
  { path: "/therapy/hepatology", name: "Therapy - Hepatology" },
  { path: "/therapy/hypertension", name: "Therapy - Hypertension" },
  { path: "/therapy/immunology", name: "Therapy - Immunology" },
  { path: "/therapy/laxatives", name: "Therapy - Laxatives" },
  { path: "/therapy/nephrology", name: "Therapy - Nephrology" },
  { path: "/therapy/neurology", name: "Therapy - Neurology" },
  { path: "/therapy/nutraceuticals", name: "Therapy - Nutraceuticals" },
  { path: "/therapy/oncology", name: "Therapy - Oncology" },
  { path: "/therapy/ophthalmology", name: "Therapy - Ophthalmology" },
  { path: "/therapy/orthopedics", name: "Therapy - Orthopedics" },
  { path: "/therapy/pediatrics", name: "Therapy - Pediatrics" },
  { path: "/therapy/pulmonary", name: "Therapy - Pulmonary" },
  { path: "/therapy/respiratory", name: "Therapy - Respiratory" },
  { path: "/therapy/rheumatology", name: "Therapy - Rheumatology" },
  { path: "/therapy/sedative-antianxiety", name: "Therapy - Sedative or Antianxiety" },
  { path: "/therapy/stimulant", name: "Therapy - Stimulant" },
  { path: "/therapy/urology", name: "Therapy - Urology" },
  { path: "/blogs", name: "Blogs" },
  { path: "/divisions", name: "Divisions" },
  { path: "/career", name: "Career" },
  { path: "/contact", name: "Contact" },
];